import axios from "axios";
import { SUPPLEMENT_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";

export interface NotificationQueryParams {
  limit?: number;
  cursor?: string;
}

export const getNotification = async (params: NotificationQueryParams) => {
  const api = axiosAuth();

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== undefined && v !== ""),
  );

  const { data } = await api.get(`${SUPPLEMENT_BASE_URL}/notification?`, {
    params: filteredParams,
  });

  return data?.data;
};

export const getUnreadNotification = async () => {
  const api = axiosAuth();

  const { data } = await api.get(
    `${SUPPLEMENT_BASE_URL}/notification/unread?limit=500`,
  );

  return data?.data.items;
};

export const markAsRead = async (sk: string) => {
  const encodedSk = encodeURIComponent(sk);

  const { data } = await axios.put(
    `${SUPPLEMENT_BASE_URL}/notification/read`,
    null, // no body
    {
      params: {
        SK: encodedSk,
      },
    },
  );

  return data;
};